import { Pipe, PipeTransform, Injectable } from '@angular/core';

import * as models from '../models/models';
@Pipe({
  name: 'timePipe'
})
@Injectable()
export class TimePipe implements PipeTransform {
  transform(time: models.Stampling): any {
    let t: string="";
    if (time.hour<10) t+= "0"
    t+=time.hour
    t+=":"
    if (time.minute<10) t+= "0"
    t+=time.minute
    return t;
  }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/pipes/TimePipe.ts